// FLAGS: none
// Browser entry point. Wraps the app in a Suspendable boundary, which never actually suspends because the
// query client's suspense option is not a React Query v5 option — see App.tsx.
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import Suspendable from "./components/wrappers/Suspendable";
import App from "./App";
import "./i18n";

import "@openup/shared/tailwind.css";

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <BrowserRouter>
    <Suspendable>
      <App />
    </Suspendable>
  </BrowserRouter>,
);
